import { cloneDeep } from 'lodash';

const defaultClaimsFilter = {
  currentPage: 1,
  pageSize: 10,
  order: 'desc',
  orderBy: 'ceReceivable',
  filters: [],
};

const defaultPharmacyFilter = {
  currentPage: 1,
  pageSize: 100,
  order: 'desc',
  orderBy: 'pharmacyNPI',
  filters: [],
};

const defaultStates = {
  // claimsManager: {
  //   hasFilterd: false,
  //   search: cloneDeep(defaultClaimsFilter),
  //   pharmacies: [],
  //   patients: [],
  //   claimStatus: {},
  //   coveredEntity: {},
  //   pharmacy: {},
  //   searchPatientTerm: '',
  //   patient: '',
  //   provider: '',
  //   searchTerms: {
  //     coveredEntityID: '',
  //     pharmacyID: '',
  //     patientID: '',
  //     rxNumber: '',
  //     providerID: '',
  //     providerFirstName: '',
  //     startDate: '',
  //     endDate: '',
  //     claimStatusID: '',
  //   },
  // },
  pharmacyreports: {
    hasFilterd: false,
    search: cloneDeep(defaultPharmacyFilter),
    chainPharmacies: [],
    pharmacies: [],
    dateRange: {},
    searchTerms: {
      startDate: '',
      endDate: '',
      showClaimID: '',
      // chainPharmacyIds: {},
      pharmacyId: {},
      claimTypeId:0,
      dateRangeID:1
    },
  },
};

const initialStates = {
  loading: false,
  claimsManager: cloneDeep(defaultStates.claimsManager),
  pharmacyreports: cloneDeep(defaultStates.pharmacyreports)
};

export { initialStates, defaultStates };
